var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargingPort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.996 9.60069L29.998 10.3948C29.999 10.7269 29.7298 10.997 29.3976 10.998H23.992V14.9987H29.3996C29.7308 14.9987 30 15.2678 30 15.5988V16.399C30 16.73 29.7308 16.9991 29.3996 16.9991H23.993V19.9997H17.3426C14.1494 19.9997 11.5047 17.4022 11.0474 14.0295H10.0877C7.14076 14.0295 5.00133 16.337 5.00133 19.5146C5.00133 22.6922 7.14076 24.9996 10.0877 24.9996H23.3906C23.7218 24.9996 23.991 25.2687 23.991 25.5997V26.3999C23.991 26.7309 23.7218 27 23.3906 27H10.0877C6.04703 27 3 23.7814 3 19.5146C3 15.2478 6.04703 12.0292 10.0877 12.0292H11.0374C11.4686 8.62551 14.1284 5.99401 17.3426 6.00001H23.993L23.987 9.00258H29.3956C29.7268 9.00258 29.995 9.26963 29.996 9.60069ZM17.3416 17.9981H21.9997V7.99316H17.3416C14.931 7.99316 12.9697 10.2376 12.9697 12.9961C12.9697 15.7536 14.931 17.9981 17.3416 17.9981Z",
    fill: "#C9C9D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingPort);
export default __webpack_public_path__ + "static/media/charging-port.4ee7728337dcb3f71e9516656d652dc6.svg";
export { ForwardRef as ReactComponent };